import React from "react";
import LayoutComponent from "@ui/layout/LayoutComponent";
import {Badge, Breadcrumb, Button, Input, Pagination, Select, Tooltip} from "antd";
import {CheckSquareOutlined, EyeOutlined, SecurityScanOutlined, UnorderedListOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {completedSystemsData} from "@store/completedSystemsData";
import "./completed-systems.scss";


const CompletedSystems = () => {
    return (
        <LayoutComponent>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <UnorderedListOutlined/>
                        <span>Список</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={'/systems'}>
                            <SecurityScanOutlined/>
                            <span>Испытания</span>
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <CheckSquareOutlined/>
                        <span>Завершены</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="listContainer">
                <div className="table-container">
                    <div className="card">
                        <div className="card-body">
                            <div className="card-title">Таблица испытаний: завершены</div>
                            <div className="search-wrapper">
                                <h4 className="search-title">Выберите вид поиска</h4>
                                <div className="search-block">
                                    <div className="select-inputs">
                                        <Select
                                            defaultValue="2022"
                                            style={{
                                                width: 120,
                                                marginRight: 20
                                            }}
                                        >
                                            <Select.Option value="2022">2022</Select.Option>
                                            <Select.Option value="2021">2021</Select.Option>
                                            <Select.Option value="2020">2020</Select.Option>
                                        </Select>
                                        <Select
                                            defaultValue="match"
                                            style={{
                                                width: 180,
                                                marginRight: 20
                                            }}
                                        >
                                            <Select.Option value="match">Соответствует</Select.Option>
                                            <Select.Option value="notMatch">Не соответствует</Select.Option>
                                        </Select>
                                    </div>
                                    <div className="search-input">
                                        <Input placeholder="поиск по названию ОИ" />
                                    </div>
                                    <Button type="primary">Найти</Button>
                                </div>
                            </div>
                            <table>
                                <thead>
                                <tr>
                                    <th>Объект испытания</th>
                                    <th>Заявитель</th>
                                    <th>Владелец</th>
                                    <th>Виды испытаний</th>
                                    <th>Год</th>
                                    <th>Вид договора</th>
                                    <th>Заключение</th>
                                    <th>Статус</th>
                                    <th>Посмотреть</th>
                                </tr>
                                </thead>
                                <tbody>
                                {completedSystemsData.map((system) => (
                                    <tr key={system.id}>
                                        <td>{system.systemName}</td>
                                        <td>{system.applicant}</td>
                                        <td>{system.owner}</td>
                                        <td>{system.workType}</td>
                                        <td>{system.year}</td>
                                        <td>{system.ContractType}</td>
                                        <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                        <td><Badge status={system.statusIndicator}/>{system.status}</td>
                                        <td>
                                            <Link to={`${system.id}`} style={{textDecoration: "none"}}>
                                                <button className="viewButton">
                                                    <Tooltip title="Посмотреть">
                                                        <EyeOutlined />
                                                    </Tooltip>
                                                </button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <div className="pagination">
                                <Pagination defaultCurrent={1} total={50}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    )
}

export default CompletedSystems;